import React from 'react';

import { Button } from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import { useLocation } from 'react-router-dom';

const AuthButtons = ({ isLogin }: { isLogin: boolean }) => {
  const location = useLocation();

  const { openModal, MODAL_TYPES } = useModal();

  const path = location.pathname;

  const isHiddenPath = path === '/guide' || path === '/blog' || path.startsWith('/listing');

  const isShow방등록하기Button = !isLogin && !isHiddenPath;

  const openLoginModal = () => {
    openModal(MODAL_TYPES.LOGIN);
  };

  return (
    <div className="relative">
      <Button
        className="h-[37px] w-[136px] whitespace-nowrap rounded-full bg-primary text-c2 font-medium text-white"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'login',
            section: 'Login menu',
          });
          openLoginModal();
        }}
      >
        Log in | Sign up
      </Button>

      {isShow방등록하기Button && (
        <Button
          className="absolute left-0 top-full my-2 h-[37px] w-[136px] rounded-full border border-primary bg-white text-c2 font-medium text-primary"
          size="lg"
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_room_listing',
              section: 'Login menu',
            });
            window.open('https://admin.checkmatekorea.com/login', '_blank');
          }}
        >
          무료로 방 등록하기
        </Button>
      )}
    </div>
  );
};

export default AuthButtons;
